/**
 *  Component: Guide Section
 */
import React from 'react';

import { Grid } from '@material-ui/core';
import styled from 'styled-components';

import MSTeamsFeaturesdImageSrc from 'assets/images/Mesh-on-MSTeams.png';

import {
  NotificationIcon1,
  GoalsIcon,
  ManagementIcon,
  Deadline2Icon,
  InterviewIcon,
  CustomerFeedbackIcon,
  CheckMarkIcon,
} from 'constants/icons';

import { FormContainer, FormHeading, Separator, Icon } from '../styles';
import IconWithText from './iconWithText';

const GuideSection = () => (
  <FormContainer>
    <FormHeading>
      <Icon>
        <NotificationIcon1 size="fixed18px" />
      </Icon>
      Here is what you can get from your Teams App
    </FormHeading>
    <Separator />
    <Container>
      <Grid container>
        <Grid xs="4" container direction="column">
          <Grid>
            <IconWithText
              icon={<GoalsIcon size="smaller" color="#3A8EE9" />}
              text="View who all are collaborating on Goals and Initiatives."
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<CustomerFeedbackIcon size="smaller" color="#3A8EE9" />}
              text="Configure custom tabs on Teams to view items from Mesh"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<ManagementIcon size="smaller" color="#3A8EE9" />}
              text="View your goals from Mesh in the list view"
            />
          </Grid>
        </Grid>
        <Grid xs="4" container direction="column">
          <StrokedImage src={MSTeamsFeaturesdImageSrc} />
        </Grid>
        <Grid xs="4" container direction="column">
          <Grid>
            <IconWithText
              icon={<InterviewIcon size="smaller" color="#3A8EE9" />}
              text="Expand goals to the the detailed goals panel and make edits all within Teams"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<CheckMarkIcon size="smaller" color="#3A8EE9" />}
              text="See collaborative action of which team members will be working on projects and tasks together"
            />
          </Grid>
          <Grid>
            <IconWithText
              icon={<Deadline2Icon size="smaller" color="#3A8EE9" />}
              text="Keep track of progress on all your Goals and Initiatives from your custom tabs on Teams"
            />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  </FormContainer>
);

const Container = styled.div`
  padding: 2rem 2rem 30px 24px;
`;

const StrokedImage = styled.img`
  width: 90%;
  border: 1px solid #eee;
`;

const ShadowedImage = styled.img`
  width: 90%;
  box-shadow: -1px 0px 12px 4px rgba(0, 0, 0, 0.13);
`;

export default GuideSection;
